function pad(n) {
  return String(n).padStart(2, '0');
}

function toIcsUtc(date) {
  return (
    date.getUTCFullYear() +
    pad(date.getUTCMonth() + 1) +
    pad(date.getUTCDate()) +
    'T' +
    pad(date.getUTCHours()) +
    pad(date.getUTCMinutes()) +
    pad(date.getUTCSeconds()) +
    'Z'
  );
}

export function getEventStartDate(ev) {
  const [hh, mm = 0] = (ev.time || '00:00').split(':').map((x) => parseInt(x, 10) || 0);
  const d = new Date();
  if (ev.eventDate && /^\d{4}-\d{2}-\d{2}$/.test(ev.eventDate)) {
    const [y, m, day] = ev.eventDate.split('-').map((x) => parseInt(x, 10));
    d.setFullYear(y, m - 1, day);
  }
  d.setHours(hh, mm, 0, 0);
  return d;
}

export function getEventEndDate(ev) {
  const start = getEventStartDate(ev);
  const minutes = ev.minutes != null ? Math.max(ev.minutes, 60) : 60;
  return new Date(start.getTime() + minutes * 60 * 1000);
}

function eventDescription(ev) {
  const parts = [];
  if (ev.description) parts.push(ev.description);
  if (ev.author) parts.push(`Järjestäjä: ${ev.author}`);
  if (ev.eventType === 'livestream') {
    const type = ev.livestreamType === 'music' ? 'Musiikki' : ev.livestreamType === 'talk' ? 'Puhe' : '';
    if (type) parts.push(`Livestriimi: ${type}`);
  }
  const room = ev.roomNumber ?? 1;
  parts.push(`Huone: ${room}`);
  return parts.join('\n');
}

export function buildIcsContent(ev, siteOrigin) {
  const start = getEventStartDate(ev);
  const end = getEventEndDate(ev);
  const uid = `${ev.id}@pulina`;
  const url = siteOrigin ? `${siteOrigin}/event/show/${ev.id}` : '';
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Pulina//Event//FI',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${toIcsUtc(new Date())}`,
    `DTSTART:${toIcsUtc(start)}`,
    `DTEND:${toIcsUtc(end)}`,
    `SUMMARY:${(ev.title || 'Tapahtuma').replace(/[,;\\]/g, ' ')}`,
    `DESCRIPTION:${eventDescription(ev).replace(/\n/g, '\\n').replace(/[,;]/g, ' ')}`,
  ];
  if (url) lines.push(`URL:${url}`);
  lines.push('END:VEVENT', 'END:VCALENDAR');
  return lines.join('\r\n');
}

export function downloadIcs(ev) {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const blob = new Blob([buildIcsContent(ev, origin)], { type: 'text/calendar;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `pulina-${ev.id || 'event'}.ics`;
  a.click();
  URL.revokeObjectURL(a.href);
}

function formatGoogleDate(d) {
  return toIcsUtc(d).replace(/[-:]/g, '').replace('Z', 'Z');
}

export function googleCalendarUrl(ev) {
  const start = getEventStartDate(ev);
  const end = getEventEndDate(ev);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: ev.title || 'Tapahtuma',
    dates: `${formatGoogleDate(start)}/${formatGoogleDate(end)}`,
    details: eventDescription(ev),
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function outlookCalendarUrl(ev) {
  const start = getEventStartDate(ev);
  const end = getEventEndDate(ev);
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: ev.title || 'Tapahtuma',
    startdt: start.toISOString(),
    enddt: end.toISOString(),
    body: eventDescription(ev),
  });
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
}

export function yahooCalendarUrl(ev) {
  const start = getEventStartDate(ev);
  const end = getEventEndDate(ev);
  const params = new URLSearchParams({
    v: '60',
    title: ev.title || 'Tapahtuma',
    st: toIcsUtc(start),
    et: toIcsUtc(end),
    desc: eventDescription(ev),
  });
  return `https://calendar.yahoo.com/?${params.toString()}`;
}

export function downloadEventCsv(ev) {
  const row = [
    ev.id,
    ev.title,
    ev.eventDate,
    ev.time,
    ev.minutes,
    ev.eventType,
    ev.author,
    ev.roomNumber ?? 1,
    ev.livestreamType || '',
    ev.livestreamCategory || '',
  ];
  const header = 'id,title,date,time,minutes,type,author,room,livestream_type,category';
  const csv = `${header}\n${row.map((c) => `"${String(c ?? '').replace(/"/g, '""')}"`).join(',')}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `pulina-${ev.id || 'event'}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}
